import { PAGES } from '@/constants/pages';

export const PRACTICE_NAVIGATION_KEYS = {
  '/D': PAGES.DASHBOARD,
  '/T': PAGES.TASKS,
  '/C': PAGES.CASES,
  '/P': PAGES.PATIENTS,
  '/F': PAGES.FILES,
} as const;

export const LAB_NAVIGATION_KEYS = {
  '/D': PAGES.LAB_DASHBOARD,
  '/T': PAGES.LAB_TASKS,
  '/O': PAGES.LAB_ORDERS,
  '/C': PAGES.LAB_CUSTOMERS,
} as const;
